import { Box, Icon, Table, Text } from '@factorialco/deprecated-design-system'
import capitalize from 'lodash/capitalize'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import getTitle from 'modules/documents/components/Documents/getTitle'
import type Folder from 'modules/documents/store/models/Folder'

interface Props {
  folder: Folder
}

const Item = ({ folder }: Props) => {
  const { navigation } = useNavigation()

  const folderDirectory = () => {
    if (folder.attributes.is_employee) {
      return i18n.t('folders.directory.employee')
    }

    if (folder.attributes.is_company) {
      return i18n.t('folders.directory.company')
    }

    return ''
  }

  const folderLink = folder.isCompany
    ? navigation.settings.folders.internal.show.fullPath({ id: folder.attributes.id })
    : navigation.settings.folders.employees.show.fullPath({ id: folder.attributes.id })

  return (
    <Table.Row.Router to={folderLink}>
      <Table.Cell>
        <Box alignItems="center" flexDirection="row" gap="s16">
          <Box flexNoShrink>
            <Icon.Large icon="folder-file" />
          </Box>
          <Text.Normal>{capitalize(getTitle(folder.attributes.name))}</Text.Normal>
        </Box>
      </Table.Cell>
      <Table.Cell>
        <Text.Normal capitalize>{capitalize(folderDirectory())}</Text.Normal>
      </Table.Cell>
      <Table.Cell>
        <Box alignItems="flexEnd">
          <Icon.Medium icon="arrow-right" />
        </Box>
      </Table.Cell>
    </Table.Row.Router>
  )
}

export default Item
